<template>
  <h-page-container>
    <h-page-header slot="pageHeader" :breadcrumb="breadcrumb" return-icon />
    <h-layout direction="vertical">
      <h-layout-header>
        <!-- 导入提示 -->
        <!-- <el-alert title="" type="info" show-icon simple /> -->
      </h-layout-header>
      <h-page-content flex align-center>
        <div class="page-import">
          <!-------------------------- 导入准备阶段 -------------------------->
          <section v-show="fileImport.phase === IMPORT_PHASE.READY" class="page-import-ready">
            <!-- 1. 导入第一步(上传文件) -->
            <section class="page-import-one">
              <!-- 1.1 上传文件 -->
              <section :class="{ 'is-error': !file.validate }" class="page-one-upload">
                <el-input v-model="file.name" placeholder="选择导入文件" readonly>
                  <el-upload
                    ref="upload"
                    slot="append"
                    :class="{ 'page-upload-disabled': file.disabled }"
                    :action="file.action"
                    :data="file.data"
                    :headers="headers"
                    :disabled="file.disabled"
                    :show-file-list="false"
                    :before-upload="handlerBeforeUpload"
                    :on-success="handlerUploadSuccess"
                    :on-error="handlerUploadFail"
                    accept=".csv"
                  >
                    <el-button icon="h-icon-folder" />
                  </el-upload>
                </el-input>
                <transition name="el-fade-in-linear">
                  <p v-show="!file.validate">请选择正确的文件类型。</p>
                </transition>
              </section>
              <!-- 1.2 上传提示 -->
              <section class="page-one-help">
                <!-- 1.2.1 字段说明 -->
                <el-tooltip placement="bottom-start">
                  <div slot="content">
                    <p v-for="(fieldTip, index) in fieldTips" :key="index">{{ fieldTip }}</p>
                  </div>
                  <a>字段说明</a>
                </el-tooltip>
                <span class="page-one-help__dividing"></span>
                <!-- 1.2.2 下载模板 -->
                <a @click="handlerDownlaodTemplate">下载文件模板</a>
                <!-- 下载区域编号对照信息文件 -->
                <span class="page-one-help__dividing"></span>
                <a @click="handlerDownlaodAreaTemplate">区域编号对照信息</a>
                <!-- 1.2.3 上传文件说明 -->
                <p>支持导入总记录数1000条以内，文件大小在10M以内的CSV格式文件。</p>
              </section>
            </section>

            <!-------------------------- 导入校验阶段 -------------------------->
            <!-- 2. 导入第二步(校验上传文件) -->
            <section class="page-import-two">
              <!-- 2.1 校验提示(校验准备阶段显示) -->
              <h3 v-show="fileImport.validating.phase === IMPORT_PHASE.READY">
                选择文件后将自动上传并进行数据校验
              </h3>
              <!-- 2.2 校验进度标题(正在校验阶段显示) -->
              <h3 v-show="fileImport.validating.phase === VALIDATE_PHASE.VALIDATE_ING">
                正在校验...
              </h3>
              <!-- 2.3 校验进度信息(正在校验阶段显示) -->
              <el-row v-show="fileImport.validating.phase === VALIDATE_PHASE.VALIDATE_ING">
                <el-col :span="12">已校验数据量：{{ fileImport.validating.validate }}</el-col>
                <el-col :span="12">已花费时 间：{{ fileImport.validating.spend }}秒</el-col>
                <el-col :span="12">总数据量：{{ fileImport.validating.total }}</el-col>
                <el-col :span="12">预计剩余时间：{{ fileImport.validating.remain }}秒</el-col>
              </el-row>
            </section>

            <!-------------------------- 校验完成阶段显示阶段 -------------------------->
            <!-- 3. 导入第三步(校验完成阶段显示) -->
            <section
              v-show="fileImport.validating.phase === VALIDATE_PHASE.VALIDATE_DONE"
              class="page-import-three"
            >
              <!-- 3.1 校验结果标题 -->
              <h3>校验完成</h3>
              <!-- 3.2 校验结果信息 -->
              <p v-show="fileImport.validated.error === 0">
                全部校验通过，共{{ fileImport.validated.total }}条数据。
              </p>
              <p v-show="fileImport.validated.error !== 0">
                共{{ fileImport.validated.total - fileImport.validated.error }}条数据通过校验，{{
                  fileImport.validated.error
                }}条数据未通过校验，未通过记录如下：
              </p>
              <!-- 3.3 校验结果列表 -->
              <el-row v-show="fileImport.validated.error !== 0" class="page-import-result">
                <!-- 3.3.1 校验结果列表标题 -->
                <el-row>
                  <el-col :span="4">位置</el-col>
                  <el-col :span="20">失败原因</el-col>
                </el-row>
                <!-- 3.3.2 校验结果列表 -->
                <el-row>
                  <div v-for="(list, index) in fileImport.validated.lists" :key="index">
                    <el-col :span="4">第{{ list.index }}行</el-col>
                    <el-col :span="20">
                      <span v-ellipsis>{{ list.message || '-' }}</span>
                    </el-col>
                  </div>
                  <div v-show="fileImport.validated.error > 5" class="page-list-more">
                    <span>
                      更多记录查看
                      <a
                        :href="
                          `${detailPageRouter}?type=VALIDATE&batchUUid=${fileImport.validateCode}`
                        "
                        place="link"
                        target="_blank"
                      >
                        校验详情
                      </a>
                      ，您可以修正数据后重新上传文件进行导入
                    </span>
                  </div>
                </el-row>
              </el-row>
              <!-- 3.4 校验重复处理(无重复信息不显示) -->
              <el-row v-show="fileImport.validated.repeat" class="page-three-repeat">
                <p>
                  其中
                  <a
                    :href="`${detailPageRouter}?type=REPEAT&batchUUid=${fileImport.validateCode}`"
                    place="link"
                    target="_blank"
                  >
                    {{ fileImport.validated.repeat }}条数据
                  </a>
                  与系统中已有数据重名，请选择处理方式：
                </p>
                <!-- 3.4.2 重复处理(更新和跳过) -->
                <el-col style="margin-top: 4px;">
                  <el-radio v-model="fileImport.oper" :label="1">更新</el-radio>
                  <span>将重名的信息更新到系统中，如果对应列值为空则不更新对应的值</span>
                </el-col>
                <el-col>
                  <el-radio v-model="fileImport.oper" :label="0">跳过</el-radio>
                  <span>不导入重名的信息</span>
                </el-col>
              </el-row>
            </section>

            <!-------------------------- 导入 -------------------------->
            <div class="page-import-button">
              <el-button :disabled="fileImport.disabled" type="primary" @click="handlerImport">
                导入
              </el-button>
            </div>

            <!-------------------------- 导入记录查询 -------------------------->
            <!-- 导入记录查询 -->
            <div
              v-show="fileImport.phase === IMPORT_PHASE.READY && records.time"
              class="page-import-records"
            >
              <div>
                上次导入：{{ records.time }} 共{{ records.success }}条数据导入成功，{{
                  records.error
                }}条数据导入失败。
                <el-button type="link" @click="handlerShowRecords">查看更多>></el-button>
              </div>
            </div>
            <!-- 导入记录详情 -->
            <import-records :visible.sync="recordsDialogVisible" />
          </section>

          <!-------------------------- 正在导入阶段 -------------------------->
          <section v-show="fileImport.phase === IMPORT_PHASE.IMPORT_ING" class="page-import-do">
            <!-- 4. 导入第四步(显示导入进度) -->
            <div class="page-import-four">
              <!-- 4.1 导入进度标题 -->
              <el-load-icon class="page-loading-icon"></el-load-icon>
              <p>正在导入...</p>
              <!-- 4.2 导入进度条 -->
              <el-progress
                :show-text="false"
                :stroke-width="12"
                :percentage="fileImport.importing.progress"
              ></el-progress>
              <!-- 4.3 导入进度信息 -->
              <el-row>
                <el-col :span="12">已导入数据量：{{ fileImport.importing.success }}</el-col>
                <el-col :span="12">已花费时 间：{{ fileImport.importing.spend }}秒</el-col>
                <el-col :span="12">总数据量：{{ fileImport.importing.total }}</el-col>
                <el-col :span="12">预计剩余时间：{{ fileImport.importing.remain }}秒</el-col>
              </el-row>
            </div>
          </section>

          <!-------------------------- 导入完成阶段 -------------------------->
          <section v-show="fileImport.phase === IMPORT_PHASE.IMPORT_DONE" class="page-import-done">
            <!-- 5. 导入第五步(显示导入结果) -->
            <div class="page-import-five">
              <h-feedback-icon icon-name="feedback_success_lg" />
              <!-- 5.1 导入结果标题 -->
              <p>导入完成</p>
              <p v-show="fileImport.imported.error === 0">
                全部导入成功，共{{ fileImport.imported.total }}条数据。
              </p>
              <p v-show="fileImport.imported.error !== 0">
                共{{ fileImport.imported.total - fileImport.imported.error }}条数据导入成功，{{
                  fileImport.imported.error
                }}条数据导入失败，失败记录如下：
              </p>
              <!-- 5.2 导入列表 -->
              <el-row v-show="fileImport.imported.error !== 0" class="page-import-result">
                <!-- 5.2.1 导入结果列表标题 -->
                <el-row>
                  <el-col :span="4">位置</el-col>
                  <el-col :span="20">失败原因</el-col>
                </el-row>
                <!-- 5.2.1 导入结果列表标题 -->
                <el-row>
                  <div v-for="(list, index) in fileImport.imported.lists" :key="index">
                    <el-col :span="4">第{{ list.index }}行</el-col>
                    <el-col :span="20">
                      <span v-ellipsis>{{ list.message || '-' }}</span>
                    </el-col>
                  </div>
                  <div v-show="fileImport.imported.error > 5" class="page-list-more">
                    <span>更多记录请查看</span>
                    <a
                      :href="`${detailPageRouter}?type=IMPORT&batchUUid=${fileImport.importCode}`"
                      place="link"
                      target="_blank"
                    >
                      导入详情
                    </a>
                  </div>
                </el-row>
              </el-row>
            </div>
            <!-- 导入结果操作 -->
            <div class="page-import-button">
              <el-button @click="handlerReturnList">返回列表</el-button>
              <el-button @click="handlerContinueImport">继续导入</el-button>
            </div>
          </section>
        </div>
      </h-page-content>
    </h-layout>
  </h-page-container>
</template>

<script>
import CON from './constant'
import ImportRecords from './CompanyImportRecords'
import api from '@/api/companyManage.api'
import qs from 'qs'
import { GET_TOKEN, GET_USER_INFO } from '@/utils/storage.utils.js'
const user = GET_USER_INFO()

export default {
  name: 'CompanyImport',
  components: { ImportRecords },
  data() {
    return {
      // 字段说明
      fieldTips: [],
      /* 文件 */
      file: {
        name: undefined, // 文件名
        validate: true,
        // TODO 加上ui
        action: `/emms/ui/v1/enterpriseService/import/validate`, // 上传文件的url
        data: null, // 上传文件时需要传送的参数，通常是组织id区域id等需要路由传入的参数，例如{id: '123'}
        disabled: false // 是否禁止文件上传
      },

      headers: {
        token: GET_TOKEN() || '',
        userId: user.userId || '',
        projectId: user.projectId || '',
        privilegedRegion: user.privilegedRegion || '',
        privilegedRegionPath: user.privilegedRegionPath || ''
      },

      /* 导入 */
      fileImport: {
        phase: CON.IMPORT_PHASE.READY, // 导入阶段(默认是导入准备阶段)
        disabled: true, // 是否禁止文件导入
        validateCode: '', // 文件校验流程标识，用于获取校验进度和校验结果
        importCode: '', // 文件导入流程标识，用于获取导入进度和导入结果
        batchUUid: undefined, // 文件导入进度查询标识(code码)
        oper: CON.IMPORT_OPER.UPDATE, // 更新/跳过(默认更新)

        validating: {
          // 导入校验进度
          phase: CON.VALIDATE_PHASE.READY, // 校验阶段(默认是校验准备阶段)
          total: 0, // 总数据量
          validate: 0, // 已校验数量
          now: 0, // 当前秒数时间
          spend: 0, // 已花费时间
          remain: 0 // 预计剩余时间
        },

        validated: {
          // 导入校验结果
          total: 0, // 总数
          error: 0, // 校验未通过数
          repeat: 0, // 重复数
          lists: [], // 错误列表
          flag: CON.REAPEAT_OPER.UPDATE // 跳过/更新(默认更新)
        },

        importing: {
          // 导入进度
          progress: 0, // 进度条
          success: 0, // 成功导入数量
          total: 0, // 总数
          now: 0, // 当前秒数时间
          spend: 0, // 已花费时间
          remain: 0 // 预计剩余时间
        },

        imported: {
          // 导入结果
          total: 0, // 总数
          error: 0, // 校验未通过数
          lists: [] // 错误列表
        }
      },

      // 导入记录列表弹窗可见性
      recordsDialogVisible: false,

      /* 导入记录详情 */
      records: {
        time: undefined, // 上次导入时间
        success: undefined, // 总共多少数据导入成功
        error: undefined // 总共多少数据导入失败
      },
      detailPageRouter: '/emms/CompanyManage/CompanyImportDetail',

      /* 常量 */
      IMPORT_PHASE: CON.IMPORT_PHASE, // 导入阶段
      VALIDATE_PHASE: CON.VALIDATE_PHASE, // 导入校验阶段
      REAPEAT_OPER: CON.REAPEAT_OPER // 重复操作
    }
  },
  created() {
    // 获取当前导入场景字段限制提示信息
    this.getImportSettingInfo()
    // 获取最近导入记录信息
    this.getRecentRecord()
  },
  methods: {
    // --------------------------------------------导入数据初始化---------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 10:43:45
     * @Desc:   导入初始化
     * @Parm:
     */
    init() {
      Object.assign(this.file, {
        name: '', // 文件名
        validate: true,
        disabled: false // 是否禁止文件上传
      })

      Object.assign(this.fileImport, {
        phase: CON.IMPORT_PHASE.READY, // 导入阶段(默认是导入准备阶段)
        disabled: true, // 是否禁止文件导入
        batchUUid: undefined, // 文件导入进度查询标识(code码)
        oper: CON.IMPORT_OPER.UPDATE, // 更新/跳过(默认更新)

        validating: {
          // 导入校验进度
          phase: CON.VALIDATE_PHASE.READY, // 校验阶段(默认是校验准备阶段)
          total: 0, // 总数据量
          validate: 0, // 已校验数量
          now: 0, // 当前秒数时间
          spend: 0, // 已花费时间
          remain: 0 // 预计剩余时间
        },

        validated: {
          // 导入校验结果
          total: 0, // 总数
          error: 0, // 校验未通过数
          repeat: 0, // 重复数
          lists: [], // 错误列表
          flag: CON.REAPEAT_OPER.UPDATE // 跳过/更新(默认更新)
        },

        importing: {
          // 导入进度
          progress: 0, // 进度条
          success: 0, // 成功导入数量
          total: 0, // 总数
          now: 0, // 当前秒数时间
          spend: 0, // 已花费时间
          remain: 0 // 预计剩余时间
        },

        imported: {
          // 导入结果
          total: 0, // 总数
          error: 0, // 校验未通过数
          lists: [] // 错误列表
        }
      })
    },

    /**
     * 下载模板文件
     * @author zhubincong
     * @since 2020-03-23 14:33:51
     */
    async handlerDownlaodTemplate() {
      const { userId, projectId } = this.headers
      const url = `${location.origin}/${
        process.env.VUE_APP_CONTEXT
      }/ui/v1/enterpriseService/importTemplate?${qs.stringify({
        userId,
        projectId
      })}`

      window.location.href = url
    },

    /**
     * @author xuchen
     * @date 2021-11-26 18:07:18
     * @desc 下载区域编号对照信息
     */
    handlerDownlaodAreaTemplate() {
      const { userId, projectId } = this.headers
      const url = `${location.origin}/${
        process.env.VUE_APP_CONTEXT
      }/ui/v1/enterpriseService/importRegionCode?${qs.stringify({
        userId,
        projectId
      })}`

      window.location.href = url
    },

    // --------------------------------------------导入准备阶段-----------------------------------------

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 10:42:49
     * @Desc:   校验上传文件的名称并上传文件
     * @Parm:
     */
    handlerBeforeUpload(file) {
      if (!file) return
      this.init()
      this.file.name = file.name

      // 文件大于10M
      if (file.size >= 10 * 1024 * 1024) {
        this.$message({
          message: `请上传文件大小在10M之内`,
          type: 'error'
        })
        return false
      }

      if (/\.csv$/.test(file.name)) {
        this.file.disabled = true
        this.fileImport.phase = CON.IMPORT_PHASE.READY // 导入准备阶段
        this.fileImport.validating.phase = CON.VALIDATE_PHASE.VALIDATE_ING // 正在校验阶段
      } else {
        this.file.validate = false
        return false
      }
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 10:48:57
     * @Desc:   文件上传成功的回调
     * @Parm:   res -> 响应参数
     */
    handlerUploadSuccess(res) {
      if (res.code !== '200' || !res.data) {
        this.init()
        this.$message({
          type: CON.ALERT_TYPE.ERROR,
          message: res.msg
        })
        return
      }
      this.fileImport.validateCode = res.data // 获取校验查询code码
      this.fileImport.phase = CON.IMPORT_PHASE.READY // 导入准备阶段
      // this.fileImport.validating.phase = CON.VALIDATE_PHASE.VALIDATE_ING; // 正在校验阶段
      this.getValidateProgress() // 获取校验进度
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 10:52:05
     * @Desc:   文件上传失败的回调
     * @Parm:
     */
    handlerUploadFail() {
      this.fileImport.phase = CON.IMPORT_PHASE.READY // 导入准备阶段
      // this.fileImport.validating.phase = CON.VALIDATE_PHASE.READY; // 校验准备阶段
      this.file.disabled = false
    },

    // --------------------------------------------导入校验阶段-----------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 10:53:04
     * @Desc:   获取上传文件的校验进度
     * @Parm:
     */
    async getValidateProgress() {
      const validating = this.fileImport.validating // 校验进度数据
      validating.now = Date.now()
      this._timer = setTimeout(async () => {
        try {
          const { data } = await api.importValidateProgress({
            batchUuid: this.fileImport.validateCode
          }) // 获取校验进度
          // 获取到的校验进度数据存到本地
          Object.assign(validating, {
            validate: data.finishCount, // 已校验数量
            total: data.totalCount, // 总数
            spend:
              Number.parseInt(validating.spend) +
              Number.parseInt((Date.now() - validating.now) / 1000) // 已花费时间
          })
          // 获取校验进度并存在本地
          let progress = data.progress

          if (!validating.spend) {
            validating.spend = 1
          } // 如果spendTime = 0, 那么设置花费时间为0.2s
          if (progress >= 1) {
            progress = 1
          } // 如果progress >= 1, 那么设置进度为1
          if (progress === 0) {
            progress = 0.1
          } // 如果progress = 0, 那么设置进度为0.1
          validating.remain = Number.parseInt((validating.spend / progress) * (1 - progress)) // 计算校验剩余时间

          if (progress >= 1) {
            clearTimeout(this._timer)
            this.getValidateResult() // 校验进度完成，则获取校验结果
          } else {
            this.getValidateProgress() // 校验进度未完成，继续获取校验进度
          }
        } catch (err) {
          clearTimeout(this._timer)
          this.init()
          console.error(err)
        }
      }, 1000) // 轮询1000ms一次
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 11:01:05
     * @Desc:   获取校验结果
     * @Parm:
     */
    async getValidateResult() {
      const fileImport = this.fileImport
      fileImport.phase = CON.IMPORT_PHASE.READY // 导入准备阶段
      fileImport.validating.phase = CON.VALIDATE_PHASE.VALIDATE_DONE // 校验完成阶段
      this.file.disabled = false
      try {
        // 这里的接口是带分页的，但是这里其实不用分页，超过6条数据就直接显示查看更多了，所以此处只加载第一页前6条
        const { data } = await api.importValidateDetail({
          batchUUid: fileImport.validateCode,
          status: CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL, // 校验失败
          pageSize: 5,
          pageNo: 1
        })
        Object.assign(fileImport.validated, {
          // 设置校验结果
          total: data.totalNum, // 总数
          error: data.errorTotalNum, // 校验未通过数
          // repeat: data.repeatNum, // 重复数
          lists: data.list // 错误列表
        })
        data.totalNum === data.errorTotalNum
          ? (fileImport.disabled = true)
          : (fileImport.disabled = false) // 全部未通过校验则不能导入操作
      } catch (err) {
        this.init()
        console.error(err)
      }
    },

    // --------------------------------------------导入阶段-----------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 11:04:52
     * @Desc:   导入文件
     * @Parm:
     */
    async handlerImport() {
      try {
        const fileImport = this.fileImport
        const params = {
          // flag: fileImport.oper, // 更新/跳过
          batchUuid: fileImport.validateCode
        }
        await api.importEnterprise(params)
        fileImport.importCode = fileImport.validateCode // 确认导入后，得到importCode，用于获取后续的导入信息
        fileImport.phase = CON.IMPORT_PHASE.IMPORT_ING // 正在导入阶段
        fileImport.validating.phase = CON.VALIDATE_PHASE.VALIDATE_DONE // 校验完成阶段
        this.getImportProgress() // 获取导入进度
      } catch (err) {
        this.init()
        console.error(err)
      }
    },

    async getImportProgress() {
      const importing = this.fileImport.importing
      importing.now = Date.now()
      this._timer = setTimeout(async () => {
        try {
          const { data } = await api.importProgress({ batchUuid: this.fileImport.importCode }) // 获取导入进度
          Object.assign(importing, {
            success: data.finishCount, // 导入成功数量
            total: data.totalCount, // 总数
            spend:
              Number.parseInt(importing.spend) +
              Number.parseInt((Date.now() - importing.now) / 1000) // 已花费时间
          })

          if (!importing.spend) {
            importing.spend = 0.2
          } // 如果spendTime = 0, 那么设置花费时间为0.2s
          let progress = data.progress // 获取导入进度
          importing.progress = Number.parseInt(100 * progress) // 设置进度条进, 百分号保留1位小数
          if (progress >= 1) {
            progress = 1
          } // 如果progress >= 1, 那么设置进度为1
          if (progress === 0) {
            progress = 0.1
          } // 如果progress = 0, 那么设置进度为0.1
          importing.remain = Number.parseInt((importing.spend / progress) * (1 - progress)) // 计算导入剩余时间

          if (progress >= 1) {
            clearTimeout(this._timer)
            this.getImportResult() // 导入进度完成，则获取导入结果
          } else {
            this.getImportProgress() // 导入进度未完成，继续获取导入进度
          }
        } catch (err) {
          clearTimeout(this._timer)
          this.init()
          console.error(err)
        }
      }, 1000) // 轮询1000ms一次
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 11:06:57
     * @Desc:   获取导入结果
     * @Parm:
     */
    async getImportResult() {
      const fileImport = this.fileImport
      fileImport.phase = CON.IMPORT_PHASE.IMPORT_DONE // 导入完成阶段
      fileImport.validating.phase = CON.VALIDATE_PHASE.VALIDATE_DONE // 校验完成阶段
      try {
        const { data } = await api.importValidateDetail({
          batchUUid: fileImport.importCode,
          status: CON.IMPORT_QUERY_TYPE.IMPORT_FAIL, // 导入失败
          pageSize: 5,
          pageNo: 1
        }) // 获取导入结果
        Object.assign(fileImport.imported, {
          // 设置导入结果
          total: data.totalNum, // 总数
          error: data.errorTotalNum, // 导入失败数
          lists: data.list // 错误列表，只去前5条超出后显示查看更多
        })
      } catch (err) {
        this.init()
        console.error(err)
      }
    },

    // --------------------------------------------导入完成阶段-----------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 11:08:30
     * @Desc:   继续导入
     * @Parm:
     */
    handlerContinueImport() {
      // this.getRecentRecord() // 获取上一次导入记录信息
      this.init()
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 11:08:49
     * @Desc:   返回列表
     * @Parm:
     */
    handlerReturnList() {
      this.$router.push({ name: 'CompanyManage' })
    },

    // --------------------------------------------导入记录查询-----------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 14:08:37
     * @Desc:   查看更多记录详情
     * @Parm:
     */
    handlerShowRecords() {
      this.recordsDialogVisible = true
      // this.records = {
      //   ...this.records
      // }
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-04-03 14:10:38
     * @Desc:   获取最近一次导入记录信息
     * @Parm:
     */
    async getRecentRecord() {
      const { data } = await api.recentImport()
      if (data) {
        this.records = {
          time: data.importTime, // 上次导入时间
          success: data.successCount, // 总共多少数据导入成功
          error: data.totalCount - data.successCount // 总共多少数据导入失败
        }
      }
    },
    /*
     * @Author: jiangyan6
     * @Date: 2019-09-03 15:19:58
     * @Desc: 获取导入模块的配置信息
     * @return: Object
     */
    async getImportSettingInfo() {
      const { data } = await api.importTemplateFields()
      this.fieldTips = data
    }
  }
}
</script>
